import NpawPlugin from 'npaw-plugin';
import NpawPluginAdapters from 'npaw-plugin-adapters';
import { getNpawVideoOptions } from './npawHelper';
import { VIDEO_OPTIONS_KEYS , NPAW_ANALYTICS_OPTIONS_KEYS, NPAW_CUSTOM_CONSTANTS} from './npawConstants';


class npawAnalytics {
  private npawPlugin: NpawPlugin | null = null;
  public static instance: npawAnalytics | null = null;

  constructor() {
    if (!npawAnalytics.instance) {
      this.npawPlugin = new NpawPlugin('zee5', {components: {balancer: false}});
      this.npawPlugin.setLogLevel(1);
      npawAnalytics.instance = this;
    }
    return npawAnalytics.instance;
  }

  getPlugin() {
    return this.npawPlugin;
  }

  setUserOptions(opts: { userName?: string; userId?: string }) {
    if (!this.npawPlugin) return;
    try {
      this.npawPlugin.setAnalyticsOptions({
        userName: opts.userName || 'web-next',
        userId: opts.userId || 'web-next-user'
      });
    } catch (e) {
      console.error('npaw setUserOptions failed', e);
    }
  }

  registerVideoAdapter(player: any, singlePlayDetails: any, userData: any, mixpanelData: any) {
    if (!this.npawPlugin) {
      console.error('NPawPlugin not initialized. Call initialize() first.');
      return;
    }
    console.log('Registering video adapter for videojs Player... **');
    try {
      if (player) {
        this.setUserOptions({});
        const videoOptions = getNpawVideoOptions(player, singlePlayDetails);
        this.npawPlugin.registerAdapterFromClass(
          player,
          NpawPluginAdapters.video.Videojs,
          videoOptions,
          '',
          () => {
            console.log('Video adapter registered successfully. **');
          }
        );
        this.npawPlugin.setAnalyticsOptions({
          [NPAW_ANALYTICS_OPTIONS_KEYS.APP_NAME]: NPAW_CUSTOM_CONSTANTS.PLAYER_NAME,
          [NPAW_ANALYTICS_OPTIONS_KEYS.VERSION]: mixpanelData?.appVersion || 'Not-Received',
          [NPAW_ANALYTICS_OPTIONS_KEYS.EMAIL]: userData?.email || NPAW_CUSTOM_CONSTANTS.NOT_RECEIVED
        });
      }
    } catch (error) {
      console.error('Failed to register video adapter:', error);
    }
  }
}

const instance = new npawAnalytics();
Object.freeze(instance);

export default instance;
